import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut as fbSignOut, onAuthStateChanged } from 'firebase/auth';

// You must provide your Firebase web config at runtime.
// Option 1: Define window.__FIREBASE_CONFIG__ in public/index.html before the bundle loads.
// Option 2: Replace the empty object below with your config.
const runtimeConfig = typeof window !== 'undefined' ? window.__FIREBASE_CONFIG__ : undefined;

const firebaseConfig = runtimeConfig || {
  apiKey: '',
  authDomain: '',
  projectId: '',
  storageBucket: '',
  messagingSenderId: '',
  appId: ''
};

let app;
let db;
let auth;
let provider;

try {
  if (!getApps().length && firebaseConfig && firebaseConfig.projectId) {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    provider = new GoogleAuthProvider();
  }
} catch (e) {
  console.error('Failed to initialize Firebase:', e);
}

export const getDb = () => db || null;
export const getAuthInstance = () => auth || null;

export const signInWithGoogle = async () => {
  if (!auth || !provider) {
    throw new Error('Firebase Auth not initialized. Provide Firebase config.');
  }
  const result = await signInWithPopup(auth, provider);
  return result.user;
};

export const signOut = async () => {
  if (!auth) return;
  await fbSignOut(auth);
};

export const subscribeToAuth = (callback) => {
  if (!auth) {
    callback(null);
    return () => {};
  }
  return onAuthStateChanged(auth, callback);
};


